<template>
  <vxe-grid
    ref="vxeGrid"
    auto-resize
    highlight-hover-row
    :data="tableData"
    :toolbar-config="tableToolbar"
    :columns="tableColumns"
    size="mini"
    resizable
    border
    round
  >
    <template v-slot:toolbar_form>
      <slot name="header">
        <div class="d-flex align-items-center">
          <div class="side-frame-danger group-title">
            {{ $l('INDEX.form_label_bankAccountNo') || '银行账号' }}
          </div>
        </div>
      </slot>
    </template>
  </vxe-grid>
</template>
<script>
export default {
  props: {
    tableData: { type: Array, default: () => [] },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: [
        {
          field: 'seq',
          width: 40,
          align: 'center',
          type: 'seq',
          fixed: 'left',
        },
        {
          title: this.$l('INDEX.table_label_bank_name') || '开户银行',
          field: 'bankName',
          headerAlign: 'center',
          align: 'center',
          minWidth: 180,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.table_label_bank_account_name') || '账户名称',
          field: 'bankAccountName',
          headerAlign: 'center',
          align: 'center',
          minWidth: 180,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.table_label_bank_account_no') || '银行账号',
          field: 'bankAccountNo',
          headerAlign: 'center',
          align: 'center',
          minWidth: 150,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.table_label_bank_account_type') || '账户性质',
          field: 'v_bankAccountType',
          headerAlign: 'center',
          align: 'center',
          minWidth: 60,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.table_label_bank_account_kind') || '账号类别',
          field: 'v_bankAccountKind',
          headerAlign: 'center',
          align: 'center',
          minWidth: 60,
          showHeaderOverflow: true,
          showOverflow: true,
        },
      ],
    }
  },
}
</script>
